import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ENCODING_LABELS } from "@/lib/crypto";
import { cn } from "@/lib/utils";

export interface EncodingSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  options: readonly string[];
  ariaLabel?: string;
  className?: string;
}

/** Compact dropdown for picking the encoding of a key, IV, or ciphertext. */
export function EncodingSelect({
  value,
  onValueChange,
  options,
  ariaLabel,
  className,
}: EncodingSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        aria-label={ariaLabel}
        className={cn("w-[116px] shrink-0", className)}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option} value={option}>
            {ENCODING_LABELS[option] ?? option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
